import { render } from "./ManagerCompanyRecordsLayout.vue?vue&type=template&id=ef3b2a1e"
import script from "./ManagerCompanyRecordsLayout.vue?vue&type=script&lang=js"
export * from "./ManagerCompanyRecordsLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__